import { createSlice } from "@reduxjs/toolkit";
import { RolesModalFieldsJSON } from "../../../pages/Settings/UserManagement/Roles/Json/RolesFieldsJson";
import { ROL_FROM_DATE, ROL_TO_DATE } from "../../../Utils/FilterDateKeys";
import dateFormat from "dateformat";
import { rolesTabs } from "../../../pages/Settings/UserManagement/Roles/Json/RolesJson";
const enterpriseid = localStorage.getItem("enterpriseid");

const initialState = {
  rolesData: [],
  organizationid: "",
  rolesFieldJson: RolesModalFieldsJSON,
  rolesEdit: {
    id: null,
    code: null,
  },
  selectedRoles: {
    tabs: rolesTabs,
    activeTab: "details",
    detailsData: {},
  },
  sorting: {
    column: "created_date",
    order: "DESC",
  },
  filter: {
    filterApi: true,
    form: {
      // enterpriseid: enterpriseid,
      // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
    formCopy: {
      [ROL_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      [ROL_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
  },
};

const rolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    setRolesData(state, action) {
      state.rolesData = action.payload;
    },
    setOrgId(state, action) {
      state.organizationid = action.payload;
    },
    setRolesFieldJson(state, action) {
      state.rolesFieldJson = action.payload;
    },
    setRolesEditID(state, action) {
      state.rolesEdit.id = action.payload;
    },
    setRolesEditCode(state, action) {
      state.rolesEdit.code = action.payload;
    },
    setRoleFilterForm(state, action) {
      switch (action?.payload.type) {
        case "reset":
          state.filter.form = {
            // [ROL_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // [ROL_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
          };
          state.filter.isFormChanged = true;
          state.filter.formCopy = state.filter.form;
          break;
        case "disableApplySpam":
          state.filter.isFormChanged = false;
          break;
        case "clearDate":
          delete state.filter.form[ROL_FROM_DATE];
          delete state.filter.form[ROL_TO_DATE];
          state.filter.isFormChanged = true;
          break;
        default:
          state.filter.form = {
            ...state.filter.form,
            [action.payload.name]: action.payload.value,
          };
          state.filter.isFormChanged = true;
      }
    },
    setRoleFilterFormCopy(state, action) {
      state.filter.formCopy = action.payload;
    },
    setRoleSorting(state, action) {
      state.sorting = {
        column: action.payload?.column,
        order: action.payload?.order,
      };
    },
    changeActiveTab: (state, action) => {
      state.selectedRoles.activeTab = action.payload;
    },
    setDetailsData: (state, action) => {
      state.selectedRoles.detailsData = action.payload;
    },
  },
});

export const {
  setRolesData,
  setOrgId,
  setRolesFieldJson,
  setRolesEditID,
  setRolesEditCode,
  setRoleFilterForm,
  setRoleFilterFormCopy,
  setRoleSorting,
  changeActiveTab,
  setDetailsData,
} = rolesSlice.actions;

export default rolesSlice.reducer;
